import DashboardRoutes from "./DashboardRoutes";

export default DashboardRoutes;
